import React, {useState} from "react";
import {EventRegistrationCreateRequest, EventSource} from "../../../shared/types/event";
import {APIResponse} from "../../../shared/types/types";
import axios from "axios";
import {EVENT_REGISTRATION_API_PATH, SERVER_URL} from "../../../../global_vars";
import Select from "react-select";
import './event-registration.scss';
import TagValidation from "../../../shared/services/validations/tag-validation";

interface EventRegistrationProps {
    eventCode: string;
    closeEventRegistrationModal: () => void;
}

function EventRegistration({eventCode, closeEventRegistrationModal}: EventRegistrationProps) {

    const [state, setState] = useState<EventRegistrationCreateRequest>({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        event_source: "",
    });

    const [status, setStatus] = useState<APIResponse>({
        code: 0,
        msg: "",
    });

    const eventSource = [
        {value: EventSource.Instagram, label: "Instagram"},
        {value: EventSource.Facebook, label: "Facebook"},
        {value: EventSource.Google, label: "Google"},
        {value: EventSource.TikTok, label: "TikTok"},
        {value: EventSource.Advertisment, label: "Advertisment"},
    ];

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setState({
            ...state,
            [name]: TagValidation(value),
        });
    }

    const handleSelectChange = (selectedOptions: any, name: keyof EventRegistrationCreateRequest) => {
        const value = Array.isArray(selectedOptions) ? selectedOptions.map((option: any) => option.value) : selectedOptions?.value;
        setState({
            ...state,
            [name]: value,
        })
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const registration: EventRegistrationCreateRequest = {
            ...state
        }
        axios.post(SERVER_URL + EVENT_REGISTRATION_API_PATH, registration).then(resp => {
            return resp.data;
        }).then(data => {
            setStatus({
                ...data
            })
            closeEventRegistrationModal();
        }).catch((error) => {
            console.log("Error: ", error);
            setStatus({
                ...error.response.data
            })
        })
    }

    return (
        <div className="event-registration">
            {
                status.code === 200
                    ?
                    <p className={"status-message"}>Thank you for reaching out to us! We will be in touch with you shortly</p>
                    :
                    <div>
                        {status.msg && (
                            <div style={{
                                color: status.code === 200 ? 'green' : 'orange',
                                textTransform: 'uppercase'
                            }}>
                                {status.msg}
                            </div>
                        )}
                        <form method="POST" onSubmit={handleSubmit}
                              className="needs-validation event-registration-form">

                            <p style={{textAlign: "center"}}>On Sat 31st May and Sun 1st June <br/> At Crowne Plaza, Edison, NJ 08817</p>

                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "1em",
                            }}>
                                <input type={"text"} className={"form-info"}
                                       id={"first_name"} name={"first_name"}
                                       value={state.first_name} onChange={handleChange}
                                       placeholder={"First Name"} required/>
                                <input type={"text"} className={"form-info"}
                                       id={"last_name"} name={"last_name"}
                                       value={state.last_name} onChange={handleChange}
                                       placeholder={"Last Name"} required/>
                            </div>

                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "1em",
                            }}>
                                <input type={"email"} className={"form-info"}
                                       id={"email"} name={"email"}
                                       value={state.email} onChange={handleChange}
                                       placeholder={"Email"} required/>
                                <input type={"tel"} className={"form-info"}
                                       id={"phone"} name={"phone"}
                                       value={state.phone} onChange={handleChange}
                                       placeholder={"Phone"} required/>
                            </div>

                            <Select options={eventSource}
                                    onChange={(selectedOptions) => handleSelectChange(selectedOptions, "event_source")}
                                    placeholder="How did you hear about us?"
                                    value={eventSource.find(source => source.value === state.event_source)}
                                    maxMenuHeight={100}
                                    isSearchable={true} required/>

                            <div className={"event-registration-form-checkbox"}>
                                <input type={"checkbox"} required/>
                                <span>
                                    By providing Luxora Dubai* your contact information, you acknowledge and agree to our Privacy Policy and consent to receiving marketing communications, including through automated calls, texts, and emails, some of which may use artificial or prerecorded voices.
                                    This consent isn’t necessary for purchasing any products or services and you may opt out at any time. To opt out from texts, you can reply, ‘stop’ at any time. To opt out from emails, you can click on the unsubscribe link in the emails. Message and data rates may apply.
                                </span>
                            </div>
                            <button className={"event-registration-form-btn"} type="submit">SUBMIT</button>

                        </form>
                    </div>
            }
        </div>
    );
}

export default EventRegistration;